import { render } from "./PageNotMade.vue?vue&type=template&id=caa24d42"
import script from "./PageNotMade.vue?vue&type=script&lang=js"
export * from "./PageNotMade.vue?vue&type=script&lang=js"

import "./PageNotMade.vue?vue&type=style&index=0&id=caa24d42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__